// NOTE: Staging
export const ONBOARDING_STAGING_ENDPOINT = "https://a3hk6ntwobbypjvlsndqmxcnue.appsync-api.ap-northeast-1.amazonaws.com/graphql"
export const ONBOARDING_STAGING_API_KEY = "da2-ln2o35fqrfgmnboye3zqey2iwm"

// NOTE: Production
export const ONBOARDING_PROD_ENDPOINT = "https://onboardingv2-api.perp.com/graphql"
export const ONBOARDING_PROD_API_KEY = "da2-xfnckzfaojbl7asdcbxogetsge"


export const ONBOARDING_PROD_ENDPOINT_NEW = "https://cf3wy4dopffbfpoppmeo3nxg5m.appsync-api.ap-southeast-1.amazonaws.com/graphql"